import { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './AuthPage.css';

export default function SignupPage() {
  const { signup, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const nextPath = location.state?.from || '/post-scrap';

  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (isLoggedIn) {
    return <Navigate to={nextPath} replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await signup({ fullName, phone, email, password });
      navigate(nextPath, { replace: true });
    } catch (err) {
      setError(err?.message || 'Could not create account. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-inner">
        <div className="auth-card">
          <h1>Sign up</h1>
          <p>Create a free SnapScrap account to post scrap for collection.</p>

          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="auth-field">
              <span>
                Full name <em>*</em>
              </span>
              <input
                type="text"
                name="full_name"
                autoComplete="name"
                placeholder="Your full name"
                required
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </label>

            <label className="auth-field">
              <span>
                Phone <em>*</em>
              </span>
              <input
                type="tel"
                name="phone"
                autoComplete="tel"
                placeholder="Your phone number"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </label>

            <label className="auth-field">
              <span>
                Email <em>*</em>
              </span>
              <input
                type="email"
                name="email"
                autoComplete="email"
                placeholder="your@email.com"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>

            <label className="auth-field">
              <span>
                Password <em>*</em>
              </span>
              <input
                type="password"
                name="password"
                autoComplete="new-password"
                placeholder="At least 6 characters"
                minLength={6}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>

            {error ? (
              <p className="auth-error" role="alert">
                {error}
              </p>
            ) : null}

            <button type="submit" className="auth-submit" disabled={submitting}>
              {submitting ? 'Creating account…' : 'Create account'}
            </button>
          </form>

          <p className="auth-switch">
            Already have an account?{' '}
            <Link to="/login" state={{ from: nextPath }}>
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
